/**
 * The message to show an admin for a failed request. The API's own `message`
 * (a sentence written for operators) wins; a network failure or an empty body
 * falls back to the caller's wording. Never the axios internals.
 */
export function errMsg(e: unknown, fallback = 'Something went wrong'): string {
  const res = (e as { response?: { data?: { message?: unknown }; status?: number } })?.response;
  const m = res?.data?.message;
  if (typeof m === 'string' && m.trim()) return m;
  if (Array.isArray(m) && m.length && typeof m[0] === 'string') return m.join('; ');
  if (res?.status === 403) return 'You do not have permission to do this.';
  if (res?.status === 404) return 'Not found — it may have been removed.';
  if (res?.status && res.status >= 500) return 'The server could not complete this. Try again.';
  if ((e as { code?: string })?.code === 'ECONNABORTED') return 'The request timed out. Try again.';
  if (!res) return 'Could not reach the server. Check your connection and try again.';
  return fallback;
}
